import React from "react";
import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CommunicationChannelKind } from "@/types/messaging-channel-config";

interface DisableChannelDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  channel: CommunicationChannelKind;
  isDefault: boolean;
  isPending: boolean;
  onConfirm: () => void;
}

export const DisableChannelDialog: React.FC<DisableChannelDialogProps> = ({
  open,
  onOpenChange,
  channel,
  isDefault,
  isPending,
  onConfirm,
}) => {
  const { t } = useTranslation();
  const channelLabel = t(`communicationChannels.channels.${channel}.label`);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>
            {t("communicationChannels.matrix.disable.title", {
              channel: channelLabel,
            })}
          </DialogTitle>
          <DialogDescription>
            {isDefault
              ? t("communicationChannels.matrix.disable.descriptionDefault")
              : t("communicationChannels.matrix.disable.description")}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            type="button"
            variant="new_outline"
            disabled={isPending}
            onClick={() => onOpenChange(false)}
          >
            {t("communicationChannels.actions.cancel")}
          </Button>
          <Button
            type="button"
            variant="new_destructive"
            disabled={isPending}
            onClick={onConfirm}
          >
            {t("communicationChannels.matrix.disable.confirm")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
